function isDefined<T>(val: T | undefined | null): val is T {
  return val !== undefined && val !== null;
}

export default <T extends object, K extends keyof T>(
  obj: T | null | undefined,
  keysToOmit: K[] = [],
): T extends object ? Omit<T, keyof T> : T => {
  let toReturn;

  if (!isDefined(obj)) {
    toReturn = obj;
  } else {
    toReturn = Object.keys(obj)
      .filter((key) => !keysToOmit.includes(key as K))
      .reduce<Partial<T>>((result, key) => {
        const keyofT = key as keyof T;
        result[keyofT] = obj[keyofT];
        return result;
      }, {});
  }

  return toReturn as unknown as T extends object ? Omit<T, K> : T;
};
